<template>
  <div>
    <form @submit.prevent="submitCategory">
      <v-row>
        <v-col
          cols="12"
          md="8"
          sm="12"
        >
          <v-card outlined>
            <v-card-text>
              <div>General</div>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="warehouse.name"
                    hide-details="auto"
                    label="Werehouse Name"
                    outlined
                    dense
                    :error-messages="errors.getMessage('name')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="warehouse.email"
                    hide-details="auto"
                    label="Werehouse Email"
                    outlined
                    dense
                    :error-messages="errors.getMessage('email')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="warehouse.phone"
                    hide-details="auto"
                    label="Werehouse Phone"
                    outlined
                    dense
                    :error-messages="errors.getMessage('phone')"
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="warehouse.location"
                    label="Location"
                    outlined
                    rows="2"
                    dense
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="12"
        >
          <v-card
            outlined
            class="mt-4"
          >
            <v-card-text>
              <div>Properties</div>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="warehouse.maxVolume"
                  hide-details="auto"
                  label="Werehouse Max Volume"
                  outlined
                  dense
                  :error-messages="errors.getMessage('maxVolume')"
                />
              </v-col>
            </v-card-text>
          </v-card>
          <div class="text-center">
            <v-btn
              color="green"
              class="ma-2 white--text"
              type="submit"
            >
              Save
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              class="ma-2"
              :to="{ name: 'WarehousesList' }"
            >
              Cancel
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      edit: false,
      warehouse: {},
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      this.getFromApi();
    }
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),

    redirect(info) {
      this.feedback(info.data.message);
      this.$router.replace({ name: "WarehousesList" });
    },
    updateWarehouse() {
      let data = this.$data.warehouse;
      window.axios.patch("/warehouse/" + data.id, data).then((response) => {
        this.redirect(response);
      });
    },
    createWarehouse() {
      window.axios.post("/warehouse", this.$data.warehouse).then((response) => {
        this.redirect(response);
      });
    },
    submitCategory() {
      if (this.$data.edit) {
        this.updateWarehouse();
      } else {
        this.createWarehouse();
      }
    },
    getFromApi() {
      window.axios
        .get("/warehouse/" + this.$route.params.id)
        .then((response) => {
          this.$data.warehouse = response.data.warehouse;
          this.$data.edit = true;
        });
    },
  },
};
</script>
